
  export const style={
    inpuStyle:{
      colorInput:"#000000"
    },
    url:{
      urlClient:"https://clubecasaacademy.prd.appnoz.com.br/",
      urlClientYouseed:"https://admyouseed.bancosemear.com.br/"
    },
    fileUrl:{
      logo:"https://timcoo-geral.s3.amazonaws.com/Logos/primary_logo_client_clubecasa.png",
      secondaryLogonLogo: "null",
    },
    variables:{
       customMenuItem: true,
       autoRegister: false,
       recaptchaVersion : "V2"
    },
    CurrencyName:{
      name:"Clube/Clubs"
    },
    teamName:{
      name:"clubecasa"
    },
    hasToken: true,
    hostHeader: "clubecasa"
  }
